import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { SecurityService } from '@connect-services/client/services/security.service';
import { TranslationLang } from '@connect-services/client/services/translate.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-profile-information',
    templateUrl: './profile-information.component.html',
})
export class ProfileInformationComponent {
    public readonly selectedLang = input<TranslationLang>(TranslationLang.FR);
    public toggleEditMode = output<void>();

    protected readonly ButtonType = ButtonType;
    protected readonly securityService = inject(SecurityService);
}
